import "core-js/modules/es.array.push.js";
import { ElMessage } from 'element-plus';
const storageKey = 'pied-piper-cdn-list';
const defaultCDNList = [{
  label: '默认',
  value: '/dcw-pied-piper',
  type: 'system'
}
// {
//   label: 'yc-h5mp',
//   value: '/yc-h5mp',
//   type: 'system',
// },
// {
//   label: '电销CRM',
//   value: '/yc-h5mp/telemarketing-crm-admin',
//   type: 'system',
// },
];
export default {
  props: {
    type: {
      type: String,
      default: 'multiple'
    },
    form: {
      type: Object
      /* default: () => ({
        quality: 75,
        format: '',
        cdn: '',
        divide: 0,
      }), */
    }
  },
  computed: {
    showAddIcon() {
      const length = this.dialogCdnList.length;
      const lastDir = this.dialogCdnList[length - 1];
      return lastDir.label && lastDir.value;
    }
  },
  watch: {
    selectCdnItem(newVal) {
      const index = this.cdnDirList.findIndex(item => item.key === newVal) || 0;
      const item = this.cdnDirList[index];
      this.options.cdnDir = index === 0 ? '' : item.value;
    }
  },
  data() {
    return {
      options: {},
      dialogFormVisible: false,
      cdnDirList: [],
      dialogCdnList: [],
      selectCdnItem: ''
    };
  },
  mounted() {
    this.options = this.form;
    this.setCdnData();
    this.options.cdnDir = '';
  },
  activated() {
    console.log('activated ', this.type);
  },
  methods: {
    getStorageData() {
      try {
        return JSON.parse(localStorage.getItem(storageKey) || '[]');
      } catch (error) {
        return [];
      }
    },
    // 获取并设置CDN目录选项
    setCdnData() {
      const cdnDirList = this.getStorageData();
      this.cdnDirList = [
      // {
      //   label: '默认',
      //   value: '/dcw-pied-piper',
      // },
      ...defaultCDNList, ...cdnDirList].map((item, index) => {
        item.key = Date.now() + '' + index;
        return item;
      });
      this.selectCdnItem = this.cdnDirList[0].key;
    },
    addLocalCdnDir() {
      this.dialogCdnList.push({
        label: '',
        value: '',
        key: String(Date.now())
      });
    },
    deleteCdnItem(index) {
      this.dialogCdnList.splice(index, 1);
    },
    showDialog() {
      ElMessage({
        type: 'warning',
        // offset: 90,
        message: '功能修改中，暂不支持自定义'
      });
      // this.dialogCdnList = JSON.parse(JSON.stringify(this.cdnDirList));
      // this.dialogFormVisible = true;
    },
    // 确认保存CDN目录列表
    confirmCdnList() {
      const list = this.dialogCdnList.filter(item => this.isValidValue(item.label) && this.isValidValue(item.value));
      this.cdnDirList = list;
      this.selectCdnItem = this.cdnDirList[0].key;
      this.options.cdnDir = '';
      localStorage.setItem(storageKey, JSON.stringify(list.filter((item, index) => index > 0)));
      this.dialogFormVisible = false;
    },
    isValidValue(value) {
      return ![null, undefined, '', '/'].includes(value);
    },
    // 完整CDN路径提示
    cdnDirTips(dir) {
      let cdnDir = dir || this.options.cdnDir;
      if (/^\/+$/.test(cdnDir)) {
        cdnDir = '';
      }
      if (cdnDir && !cdnDir.startsWith('/')) {
        cdnDir = `/${cdnDir}`;
      }
      cdnDir = cdnDir || '/dcw-pied-piper';
      return 'https://img5.bitautoimg.com' + cdnDir;
    }
  }
};